document.addEventListener('DOMContentLoaded', () => {
    const selector = '.tabs';
    if ((document.querySelector(selector) !== null)) {
        import('./tabs').then(({ tabs }) => {
            tabs();
        });
    }
});
